import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  CHECK_TOKEN_REQUEST: null,
  CHECK_TOKEN_REQUEST_SUCCESS: null,
  CHECK_TOKEN_REQUEST_FAILED: null,

  REGISTER_ACCOUNT_REQUEST: null,
  REGISTER_ACCOUNT_REQUEST_SUCCESS: null,
  REGISTER_ACCOUNT_REQUEST_FAILED: null,

  REGISTER_STATUS_REQUEST: null,
  REGISTER_STATUS_REQUEST_SUCCESS: null,
  REGISTER_STATUS_REQUEST_FAILED: null,

  HAS_REGISTERED: null,

  FILL_BANK_CODE: null,

  FILL_TOKEN: null,

  FILL_BANK_CREDENTIALS: null,

  FINISHED_POLLING: null,

  SET_HAS_CALLED_POLLING: null,

  SET_FIRST_POLLING_TIME: null,
});
